import createStore from 'widgets/lib/create-store'

import model from './model'


let {
  store,
  Provider,
  useStore
} = createStore(model.Model, model.initState);

export {
  store,
  Provider,
  useStore
}


